import { render, staticRenderFns } from "./Museums.vue?vue&type=template&id=ce7c05c8&"
import script from "./Museums.vue?vue&type=script&lang=js&"
export * from "./Museums.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports